/**
 * StudentDashboard timing constants
 *
 * These values control animation timing, refetch intervals, and UI delays.
 * Centralizing them makes it easy to tune the UX and understand the timing sequences.
 */

// ===== Data Fetching =====

/**
 * How long before cached dashboard data is considered stale, gating the
 * tab-visibility refetch in useDashboardData. The previous value (10s) made
 * every Alt-Tab return fire a fresh /students/:id/dashboard request — an
 * admin keeping the tab open for an hour fired 34 wasted fetches that way
 * (PostHog data, 2026-04-13). Bumped to 5 min: still fresh enough to catch
 * teacher reviews on a long tab-away, no longer chatty for normal browsing.
 */
export const STALE_THRESHOLD_MS = 5 * 60 * 1000;

/** Time-of-day update interval (ms) - checks every minute */
export const TIME_OF_DAY_UPDATE_INTERVAL = 60000;


// ===== Level-Up Animation =====

/** Delay before showing level-up modal (allows XP animation to complete) */
export const LEVEL_UP_MODAL_DELAY = 800;
